<div class="d-flex flex-column h-100 overflow-hidden">
    <app-header></app-header>
    <section class="flex-grow-1 overflow-hidden">
        <router-outlet></router-outlet>
    </section>
    <app-footer></app-footer>
</div>
